import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/index.scss';

async function enableMocking() {
  if (!process.env.REACT_APP_MOCK_API || process.env.REACT_APP_MOCK_API !== 'true') {
    return;
  }

  const {worker} = await import('./mocks/browser');

  return worker.start({
    onUnhandledRequest: 'bypass', // 忽略所有未處理的請求
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

window.assetUrl = (relativePath) => {
  const baseUrl = process.env.REACT_APP_ASSET_URL;
  const version = process.env.REACT_APP_VERSION;
  return `${baseUrl}${relativePath}?ver=${version}`;
};
enableMocking().then(() => {
  root.render(
    <App />,
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
